import { memo, useEffect, useLayoutEffect, useState } from 'react';

import { Button, Checkbox, Flex, Group, Modal, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

import { PassTypesResponseType } from '@/types/pass-types';
import { PassFormFields } from '@/types/passes';
import { PersonPass } from '@/types/person';

import { Select } from '@/shared/uikit/components/input';

interface PassFormProps {
	isOpen: boolean;
	pass: PersonPass | undefined | null;
	passTypes: PassTypesResponseType | undefined;
	onUpdate: ({ id, body }: { id: number; body: PassFormFields }) => Promise<void>;
	onCreate: (body: PassFormFields) => Promise<void>;
	handleClose: () => void;
}

function PassForm({ isOpen, pass, passTypes, onCreate, onUpdate, handleClose }: PassFormProps) {
	const form = useForm({
		initialValues: {
			pass_type_id: pass?.pass_type_id ?? 0,
			car_number: pass?.car_number ?? '',
			is_vip: pass?.is_vip ?? false,
		},
		validate: {
			car_number: (value) => {
				if (
					passTypes?.objects.find((pass) => pass.id === form.getInputProps('pass_type_id').value)
						?.kind === 'car' &&
					!value
				) {
					return 'Введите значение';
				}
			},
		},
	});

	useEffect(() => {
		form.setValues({
			pass_type_id: pass?.pass_type_id ?? 0,
			car_number: pass?.car_number ?? '',
			is_vip: pass?.is_vip ?? false,
		});
	}, [pass]);

	const handleSubmit = async (data: PassFormFields) => {
		if (pass) {
			await onUpdate({ id: pass.id, body: data });
			handleClose();
			return;
		}
		await onCreate(data);
		handleClose();
	};

	return (
		<Modal
			title={`${pass ? 'Изменение' : 'Создание'} пропуска`}
			opened={isOpen}
			onClose={handleClose}
			centered
			size="md"
		>
			<form
				onSubmit={form.onSubmit((values) => {
					handleSubmit(values);
				})}
			>
				<Flex direction="column" gap="md">
					<Select
						caption="Название"
						w="100%"
						data={
							passTypes?.objects
								?.filter((elem) => !elem.is_deleted)
								.map((elem) => {
									return { value: `${elem.id}`, label: elem.name };
								}) ?? []
						}
						defaultValue={`${pass?.pass_type_id}`}
						placeholder="Выберите тип пропуска"
						searchable
						onChange={(value) => {
							form.getInputProps('pass_type_id').onChange(Number(value));
						}}
					/>
					{passTypes?.objects.find((pass) => pass.id === form.getInputProps('pass_type_id').value)
						?.kind === 'car' && (
						<TextInput
							{...form.getInputProps('car_number')}
							label="Описание"
							placeholder="Введите описание пропуска"
						/>
					)}
					<Checkbox label="VIP" {...form.getInputProps('is_vip', { type: 'checkbox' })} />
					<Group gap="md">
						<Button radius="sm" type="submit" disabled={!form.values.pass_type_id}>
							ОК
						</Button>
						<Button radius="sm" color="red" onClick={handleClose}>
							Отмена
						</Button>
					</Group>
				</Flex>
			</form>
		</Modal>
	);
}

export default memo(PassForm);
